import { DiameterField } from '~/purchase/components';

type Props = {
  rowIndex: number;
  onRemoveRow: (index: number) => void;
};

/**
 * The diameter criterion of one row, entered with the same widget as the quote pricing policies so
 * both screens read the same way.
 */
export function AdvancedBonusDiameterRow({ rowIndex, onRemoveRow }: Props) {
  return (
    <DiameterField
      refinementIndex={rowIndex}
      baseName={`diameters.${rowIndex}` as const}
      onRemoveRow={onRemoveRow}
      mode='WRITE'
    />
  );
}
